import "./Jimi.css";

export default function Jimi({ size = "small", decorative = true, className = "" }) {
  return <img src="/brand/jimi.png" alt={decorative ? "" : "Jimi, la mascotte JM Intérim"} aria-hidden={decorative ? true : undefined} width="100" height="110" decoding="async" className={`jm-jimi jm-jimi--${size} ${className}`} />;
}

export function JimiEmpty({ children }) {
  return <div className="jm-jimi-empty"><Jimi size="medium" /><p>{children}</p></div>;
}
